import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import NeedSupportLinks from './NeedSupportLinks';
import {
  BubbleText,
  HelpParentContainer,
} from '../../../../styled-components/HelpStyledComponents';
import useTranslate from '../../../../hooks/useTranslate';

const Panel1AHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#f4ead2"
      bubbleTitle={`${t('panel1AHelp-bubbleTitle')}`}
      bubbleContent={`${t('panel1AHelp-bubbleContent')}`}
      url="https://scribehow.com/shared/Create_Account_as_New_User__YJHS_LXuRQGIqV4MVpxTTA"
    />
  );
};

export default Panel1AHelp;

export const HelpPanelTemplate = (props: {
  bubbleTitle: string;
  bubbleContent: string | ReactElement;
  bubbleColor: string;
  url?: string;
}) => {
  const t = useTranslate();

  return (
    <HelpParentContainer>
      <Box marginBottom="10px">
        <Typography variant="h2" lineHeight={1.5} fontFamily={'Nunito'} tabIndex={0}>
          {t('panel1AHelp-welcome')}
        </Typography>
      </Box>

      <HelpTextBubble color={props.bubbleColor}>
        <>
          <Typography
            variant="h3"
            fontFamily={'Nunito'}
            fontWeight="bold"
            lineHeight={1.5}
            tabIndex={0}
          >
            {props.bubbleTitle}
          </Typography>
          <Typography variant="body1" fontWeight={500} lineHeight={1.5} tabIndex={0}>
            {props.bubbleContent}
          </Typography>
        </>
      </HelpTextBubble>

      <NeedSupportLinks url={props.url} />
    </HelpParentContainer>
  );
};

const HelpTextBubble = (props: { color: string; children: JSX.Element }) => {
  return (
    <BubbleText backgroundColor={props.color}>
      <Box>{props.children}</Box>
    </BubbleText>
  );
};
